/**
 * Reusable Toggle Component
 * Used for switching between two view modes (e.g., My/All, Open/All)
 */
import React from 'react';

const ViewToggle = ({ 
  leftLabel, 
  rightLabel, 
  activeView, 
  onToggle, 
  leftValue = 'left',
  rightValue = 'right',
  activeColor = 'bg-blue-600',
  className = ''
}) => {
  return (
    <div className={`flex items-center gap-2 bg-white rounded-lg border border-gray-300 p-1 ${className}`}>
      <button
        onClick={() => onToggle(leftValue)}
        className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
          activeView === leftValue
            ? `${activeColor} text-white`
            : 'text-gray-600 hover:bg-gray-100'
        }`}
        data-testid={`toggle-${leftValue}`}
      >
        {leftLabel}
      </button>
      <button
        onClick={() => onToggle(rightValue)}
        className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
          activeView === rightValue
            ? `${activeColor} text-white`
            : 'text-gray-600 hover:bg-gray-100'
        }`}
        data-testid={`toggle-${rightValue}`}
      >
        {rightLabel}
      </button>
    </div>
  );
};

export default ViewToggle;
